import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  RestaurantContextService
} from '../../core/restaurant-context.service';
import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.css'
})
export class ProductsComponent implements OnInit {

  restaurants: any[] = [];
  categories: any[] = [];
  products: any[] = [];

  restaurantId: any = '';
  newCategory = '';

  selectedCategoryImage: File | null = null;
categoryImagePreview: string | null = null;

changingImageCategoryId: number | null = null;
changingStatusCategoryId: number | null = null;
deletingCategoryId: number | null = null;


  selectedImage: File | null = null;
  imagePreview: string | null = null;

  loadingProducts = false;
  savingCategory = false;
  savingProduct = false;
  changingImageProductId: number | null = null;
  changingStatusProductId: number | null = null;
  editingProductId: number | null = null;
deletingProductId: number | null = null;

  error = '';
  success = '';

  form: any = this.createEmptyForm();

  constructor(
    private api: ApiService,
   private restaurantContext:
    RestaurantContextService
  ) {}

  ngOnInit(): void {
    this.loadRestaurants();
  }

  createEmptyForm() {
    return {
      categoryId: '',
      name: '',
      description: '',
      price: 0,
      isActive: true
    };
  }

  loadRestaurants(): void {
    this.api.get<any[]>('/restaurants').subscribe({
      next: (restaurants) => {
        this.restaurants = restaurants;

        // if (restaurants.length) {
        //   this.restaurantId =
        //     restaurants[0].id;

        //   this.loadAll();
        // }

        if (restaurants.length) {
  const selectedRestaurant =
    restaurants[0];

  this.restaurantId =
    selectedRestaurant.id;

  this.restaurantContext.setRestaurant({
    id: selectedRestaurant.id,
    name: selectedRestaurant.name,
    role: selectedRestaurant.role
  });

  this.loadAll();
}
      },
      error: (error) => {
        this.error =
          error?.error?.message ||
          'Erro ao carregar restaurantes.';
      }
    });
  }

  loadAll(): void {
    if (!this.restaurantId) {
      this.categories = [];
      this.products = [];
      return;
    }

    this.error = '';
    this.loadingProducts = true;

    /*
     * Categoria continua usando a rota antiga,
     * pois ainda não alteramos o backend dela.
     */
    this.api
      .get<any[]>(
        `/categories?restaurantId=${Number(this.restaurantId)}`
      )
      .subscribe({
        next: (categories) => {
          this.categories = categories;
        },
        error: (error) => {
          this.error =
            error?.error?.message ||
            'Erro ao carregar categorias.';
        }
      });

    /*
     * Antes:
     * /products?restaurantId=1
     *
     * Agora:
     * /restaurants/1/products
     */
    this.api
      .get<any[]>(
        `/restaurants/${Number(this.restaurantId)}/products`
      )
      .subscribe({
        next: (products) => {
          this.products = products;
          this.loadingProducts = false;
        },
        error: (error) => {
          this.loadingProducts = false;

          this.error =
            error?.error?.message ||
            'Erro ao carregar produtos.';
        }
      });
  }

  onRestaurantChange(): void {
    this.form = this.createEmptyForm();
    this.newCategory = '';
    this.selectedImage = null;
    this.imagePreview = null;
    this.selectedCategoryImage = null;
    this.categoryImagePreview = null;
    this.success = '';
    this.error = '';

    this.loadAll();
  }



toggleCategory(
  category: any
): void {

  this.error = '';
  this.success = '';

  this.changingStatusCategoryId =
    category.id;

  this.api
    .put<any>(
      `/categories/${category.id}`,
      {
        isActive:
          !category.isActive
      }
    )
    .subscribe({

      next: (updatedCategory) => {

        category.isActive =
          updatedCategory.isActive;

        this.changingStatusCategoryId =
          null;

        this.success =
          category.isActive
            ? 'Categoria ativada com sucesso.'
            : 'Categoria inativada com sucesso.';
      },

      error: (error) => {

        this.changingStatusCategoryId =
          null;

        this.error =
          error?.error?.message ||
          'Erro ao alterar a categoria.';
      }

    });
}









editProduct(product: any): void {
  this.error = '';
  this.success = '';

  this.editingProductId =
    product.id;

  this.form = {
    categoryId:
      product.categoryId ||
      product.category?.id ||
      '',

    name:
      product.name || '',

    description:
      product.description || '',

    price:
      Number(product.price || 0),

    isActive:
      Boolean(product.isActive)
  };

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}






cancelProductEdit(): void {
  this.editingProductId =
    null;

  this.form =
    this.createEmptyForm();

  this.selectedImage =
    null;

  this.imagePreview =
    null;

  this.error = '';
}


deleteProduct(
  product: any
): void {

  const confirmed =
    confirm(
      `Deseja realmente excluir "${product.name}"?`
    );

  if (!confirmed) {
    return;
  }

  this.deletingProductId =
    product.id;

  this.api
    .delete<any>(
      `/restaurants/${Number(this.restaurantId)}/products/${product.id}`
    )
    .subscribe({

      next: () => {

        this.deletingProductId =
          null;

        this.success =
          'Produto excluído com sucesso.';

        this.loadAll();
      },

      error: (error) => {

        this.deletingProductId =
          null;

        this.error =
          error?.error?.message ||
          'Erro ao excluir produto.';
      }

    });
}


deleteCategory(
  category: any
): void {

  this.error = '';
  this.success = '';

  const productCount =
    category.products?.length || 0;

  if (productCount > 0) {

    this.error =
      'Esta categoria possui produtos. Mova ou exclua os produtos antes de excluir a categoria.';

    return;
  }

  const confirmed =
    confirm(
      `Deseja realmente excluir a categoria "${category.name}"?`
    );

  if (!confirmed) {
    return;
  }

  this.deletingCategoryId =
    category.id;

  this.api
    .delete<any>(
      `/categories/${category.id}`
    )
    .subscribe({

      next: () => {

        this.deletingCategoryId =
          null;

        this.success =
          'Categoria excluída com sucesso.';

        this.loadAll();
      },

      error: (error) => {

        this.deletingCategoryId =
          null;

        this.error =
          error?.error?.message ||
          'Erro ao excluir categoria.';
      }

    });
}













onCategoryImageSelected(
  event: Event
): void {

  const input =
    event.target as HTMLInputElement;

  const file =
    input.files?.[0];

  if (!file) {
    return;
  }

  if (!file.type.startsWith('image/')) {
    this.error =
      'Selecione uma imagem válida para a categoria.';

    input.value = '';

    return;
  }

  this.selectedCategoryImage =
    file;

  const reader =
    new FileReader();

  reader.onload = () => {
    this.categoryImagePreview =
      reader.result as string;
  };

  reader.readAsDataURL(
    file
  );
}


removeSelectedCategoryImage(): void {
  this.selectedCategoryImage =
    null;

  this.categoryImagePreview =
    null;
}


  // createCategory(): void {
  //   this.error = '';
  //   this.success = '';

  //   const categoryName =
  //     this.newCategory.trim();

  //   if (!this.restaurantId) {
  //     this.error =
  //       'Selecione um restaurante.';
  //     return;
  //   }

  //   if (!categoryName) {
  //     this.error =
  //       'Informe o nome da categoria.';
  //     return;
  //   }

  //   this.savingCategory = true;

  //   /*
  //    * Categoria continua usando a rota antiga.
  //    */
  //   this.api
  //     .post<any>('/categories', {
  //       restaurantId:
  //         Number(this.restaurantId),
  //       name: categoryName
  //     })
  //     .subscribe({
  //       next: (createdCategory) => {
  //         this.savingCategory = false;
  //         this.newCategory = '';

  //         this.success =
  //           'Categoria criada com sucesso.';

  //         this.loadAll();

  //         if (createdCategory?.id) {
  //           this.form.categoryId =
  //             createdCategory.id;
  //         }
  //       },
  //       error: (error) => {
  //         this.savingCategory = false;

  //         this.error =
  //           error?.error?.message ||
  //           'Erro ao criar categoria.';
  //       }
  //     });
  // }




uploadCategoryImage(
  categoryId: number
): void {

  if (
    !this.selectedCategoryImage
  ) {
    this.finishCategoryCreation();

    return;
  }

  const formData =
    new FormData();

  formData.append(
    'image',
    this.selectedCategoryImage
  );

  this.api
    .post<any>(
      `/categories/${categoryId}/image`,
      formData
    )
    .subscribe({

      next: () => {
        this.finishCategoryCreation();
      },

      error: (error) => {

        this.savingCategory =
          false;

        this.error =
          error?.error?.message ||
          'Categoria criada, mas houve erro ao enviar a imagem.';

        this.selectedCategoryImage =
          null;

        this.categoryImagePreview =
          null;

        this.loadAll();
      }

    });
}


finishCategoryCreation(
  createdCategory?: any
): void {

  this.savingCategory =
    false;

  this.success =
    'Categoria criada com sucesso.';

  this.newCategory =
    '';

  this.selectedCategoryImage =
    null;

  this.categoryImagePreview =
    null;

  this.loadAll();

  if (
    createdCategory?.id
  ) {
    this.form.categoryId =
      createdCategory.id;
  }
}

changeCategoryImage(
  event: Event,
  category: any
): void {

  const input =
    event.target as HTMLInputElement;

  const file =
    input.files?.[0];

  if (!file) {
    return;
  }

  if (
    !file.type.startsWith(
      'image/'
    )
  ) {

    alert(
      'Selecione um arquivo de imagem válido.'
    );

    input.value = '';

    return;
  }

  this.changingImageCategoryId =
    category.id;

  const formData =
    new FormData();

  formData.append(
    'image',
    file
  );

  this.api
    .post<any>(
      `/categories/${category.id}/image`,
      formData
    )
    .subscribe({

      next: (response) => {

        category.imageUrl =
          response?.imageUrl ||
          response?.category
            ?.imageUrl ||
          category.imageUrl;

        this.changingImageCategoryId =
          null;

        input.value = '';

        this.success =
          'Imagem da categoria atualizada com sucesso.';

        this.loadAll();
      },

      error: (error) => {

        this.changingImageCategoryId =
          null;

        input.value = '';

        alert(
          error?.error?.message ||
          'Erro ao trocar a imagem da categoria.'
        );
      }

    });
}



  createCategory(): void {
  this.error = '';
  this.success = '';

  const categoryName =
    this.newCategory.trim();

  if (!this.restaurantId) {
    this.error =
      'Selecione um restaurante.';

    return;
  }

  if (!categoryName) {
    this.error =
      'Informe o nome da categoria.';

    return;
  }

  this.savingCategory =
    true;

  this.api
    .post<any>(
      '/categories',
      {
        restaurantId:
          Number(
            this.restaurantId
          ),

        name:
          categoryName
      }
    )
    .subscribe({

      next: (
        createdCategory
      ) => {

        /*
         * Se selecionou uma imagem,
         * envia depois de criar.
         */
        if (
          this.selectedCategoryImage &&
          createdCategory?.id
        ) {

          this.uploadCategoryImage(
            createdCategory.id
          );

          return;
        }

        this.finishCategoryCreation(
          createdCategory
        );
      },

      error: (error) => {
        this.savingCategory =
          false;

        this.error =
          error?.error?.message ||
          'Erro ao criar categoria.';
      }

    });
}







saveProduct(): void {
  this.error = '';
  this.success = '';

  const payload = {
    categoryId:
      Number(this.form.categoryId),

    name:
      this.form.name?.trim(),

    description:
      this.form.description?.trim() ||
      null,

    price:
      Number(this.form.price || 0),

    isActive:
      Boolean(this.form.isActive)
  };

  if (!this.restaurantId) {
    this.error =
      'Selecione um restaurante.';

    return;
  }

  if (!payload.categoryId) {
    this.error =
      'Selecione uma categoria.';

    return;
  }

  if (!payload.name) {
    this.error =
      'Informe o nome do produto.';

    return;
  }

  if (payload.price <= 0) {
    this.error =
      'Informe um preço válido.';

    return;
  }

  this.savingProduct =
    true;

  /*
   * EDIÇÃO
   */
  if (this.editingProductId) {

    this.api
      .put<any>(
        `/restaurants/${Number(this.restaurantId)}/products/${this.editingProductId}`,
        payload
      )
      .subscribe({

        next: () => {
          this.savingProduct =
            false;

          this.editingProductId =
            null;

          this.form =
            this.createEmptyForm();

          this.success =
            'Produto atualizado com sucesso.';

          this.loadAll();
        },

        error: (error) => {
          this.savingProduct =
            false;

          this.error =
            error?.error?.message ||
            'Erro ao atualizar produto.';
        }

      });

    return;
  }

  /*
   * CRIAÇÃO
   */
  this.api
    .post<any>(
      `/restaurants/${Number(this.restaurantId)}/products`,
      payload
    )
    .subscribe({

      next: (createdProduct) => {

        if (this.selectedImage) {
          this.uploadImage(
            createdProduct.id
          );

          return;
        }

        this.finishProductCreation();
      },

      error: (error) => {
        this.savingProduct =
          false;

        this.error =
          error?.error?.message ||
          'Erro ao salvar produto.';
      }

    });
}











  createProduct(): void {
    this.error = '';
    this.success = '';

    /*
     * O restaurantId foi removido do payload.
     *
     * Agora ele é enviado na URL.
     */
    const payload = {
      categoryId:
        Number(this.form.categoryId),
      name:
        this.form.name?.trim(),
      description:
        this.form.description?.trim() ||
        null,
      price:
        Number(this.form.price || 0),
      isActive:
        Boolean(this.form.isActive)
    };

    if (!this.restaurantId) {
      this.error =
        'Selecione um restaurante.';
      return;
    }

    if (!payload.categoryId) {
      this.error =
        'Selecione uma categoria.';
      return;
    }

    if (!payload.name) {
      this.error =
        'Informe o nome do produto.';
      return;
    }

    if (payload.price <= 0) {
      this.error =
        'Informe um preço válido.';
      return;
    }

    this.savingProduct = true;

    /*
     * Antes:
     * POST /products
     *
     * Agora:
     * POST /restaurants/1/products
     */
    this.api
      .post<any>(
        `/restaurants/${Number(this.restaurantId)}/products`,
        payload
      )
      .subscribe({
        next: (createdProduct) => {
          if (this.selectedImage) {
            this.uploadImage(
              createdProduct.id
            );
            return;
          }

          this.finishProductCreation();
        },
        error: (error) => {
          this.savingProduct = false;

          this.error =
            error?.error?.message ||
            'Erro ao salvar produto.';
        }
      });
  }

  finishProductCreation(): void {
    this.savingProduct = false;

    this.success =
      'Produto criado com sucesso.';

    this.form =
      this.createEmptyForm();

    this.selectedImage = null;
    this.imagePreview = null;

    this.loadAll();
  }

  onImageSelected(event: Event): void {
    const input =
      event.target as HTMLInputElement;

    const file =
      input.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.error =
        'Selecione um arquivo de imagem válido.';

      input.value = '';
      return;
    }

    this.selectedImage = file;

    const reader =
      new FileReader();

    reader.onload = () => {
      this.imagePreview =
        reader.result as string;
    };

    reader.readAsDataURL(file);
  }

  removeSelectedImage(): void {
    this.selectedImage = null;
    this.imagePreview = null;
  }

  uploadImage(productId: number): void {
    if (!this.selectedImage) {
      this.finishProductCreation();
      return;
    }

    const formData =
      new FormData();

    formData.append(
      'image',
      this.selectedImage
    );

    /*
     * Antes:
     * /products/10/image
     *
     * Agora:
     * /restaurants/1/products/10/image
     */
    this.api
      .post<any>(
        `/restaurants/${Number(this.restaurantId)}/products/${productId}/image`,
        formData
      )
      .subscribe({
        next: () => {
          this.finishProductCreation();
        },
        error: (error) => {
          this.savingProduct = false;

          this.error =
            error?.error?.message ||
            'Produto criado, mas houve erro ao enviar a imagem.';

          this.form =
            this.createEmptyForm();

          this.selectedImage = null;
          this.imagePreview = null;

          this.loadAll();
        }
      });
  }

  changeProductImage(
    event: Event,
    product: any
  ): void {
    const input =
      event.target as HTMLInputElement;

    const file =
      input.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      alert(
        'Selecione um arquivo de imagem válido.'
      );

      input.value = '';
      return;
    }

    this.changingImageProductId =
      product.id;

    const formData =
      new FormData();

    formData.append(
      'image',
      file
    );

    /*
     * Antes:
     * /products/10/image
     *
     * Agora:
     * /restaurants/1/products/10/image
     */
    this.api
      .post<any>(
        `/restaurants/${Number(this.restaurantId)}/products/${product.id}/image`,
        formData
      )
      .subscribe({
        next: (response) => {
          product.imageUrl =
            response?.imageUrl ||
            response?.product?.imageUrl ||
            product.imageUrl;

          this.changingImageProductId =
            null;

          input.value = '';

          this.success =
            'Imagem atualizada com sucesso.';

          this.loadAll();
        },
        error: (error) => {
          this.changingImageProductId =
            null;

          input.value = '';

          alert(
            error?.error?.message ||
            'Erro ao trocar a imagem do produto.'
          );
        }
      });
  }

  toggle(product: any): void {
    this.changingStatusProductId =
      product.id;

    /*
     * Antes:
     * PUT /products/10
     *
     * Agora:
     * PUT /restaurants/1/products/10
     */
    this.api
      .put<any>(
        `/restaurants/${Number(this.restaurantId)}/products/${product.id}`,
        {
          isActive:
            !product.isActive
        }
      )
      .subscribe({
        next: (updatedProduct) => {
          product.isActive =
            updatedProduct?.isActive ??
            !product.isActive;

          this.changingStatusProductId =
            null;
        },
        error: (error) => {
          this.changingStatusProductId =
            null;

          alert(
            error?.error?.message ||
            'Erro ao alterar o status do produto.'
          );
        }
      });
  }

  getImageUrl(
    imageUrl: string
  ): string {
    if (!imageUrl) {
      return '';
    }

    if (
      imageUrl.startsWith('http://') ||
      imageUrl.startsWith('https://') ||
      imageUrl.startsWith('data:')
    ) {
      return imageUrl;
    }

    return `http://localhost:3000${imageUrl}`;
  }

  formatMoney(value: any): string {
    return new Intl.NumberFormat(
      'pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }
    ).format(
      Number(value || 0)
    );
  }

  trackByProductId(
    index: number,
    product: any
  ): number {
    return product.id;
  }
}